import React from 'react';
import Section from './section';
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Analytics = () => {
  const data = useStaticQuery(graphql`
    query AnalyticsQuery {
      shotCharts: file(absolutePath: { regex: "/analytics\/shot-charts.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2)
        }
      }
      draftBoard: file(absolutePath: { regex: "/analytics\/draft-board.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2)
        }
      }
      wnbaDraftBoard: file(absolutePath: { regex: "/analytics\/wnba-draft-board.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 2)
        }
      }
    }
  `);
       
  return (
    <Section 
      anchor='analytics'
      title='Sports Analytics'
      subtitle='I like sports + analytics'
      index={3}
      >
      
      <div className='columns'>
          <Item
            title='NBA Draft Rankings'
            details='Draft board with rankings compiled from across the web'
            url='http://tothemean.com/tools/draft-models/#/'
            image={data.draftBoard.childImageSharp.gatsbyImageData}
            />
          <Item
            title='WNBA Draft Rankings'
            details='Draft board with rankings compiled from across the web'
            url='https://tothemean.com/tools/wnba-draft-models/#/2021/ws/all'
            image={data.wnbaDraftBoard.childImageSharp.gatsbyImageData}
            />
          <Item
            title='NBA Shot Charts'
            details='JavaScript library to help build shot charts similar to Goldsberry'
            url='https://github.com/virajsanghvi/d3.basketball-shot-chart'
            image={data.shotCharts.childImageSharp.gatsbyImageData}
            />
      </div>
 
    </Section>
  );
}

export default Analytics; 

const Item = ({title, details, image, url}) => {
  return (
    <div className='analytics-item column is-one-third'>
      <div className='card'>  
        <div className='card-image'>  
          <a href={url}>  
            <GatsbyImage
              as='figure'
              className='image img-hover'
              image={image}
              alt={title}
              style={{
                width: '100%',
              }}
              placeholder='none'
              sizes='(min-width: 769px) 33vw, 100vw'
            />
          </a>
        </div>
        <div className="card-content">
          <h4 className='title is-5'>
            <a href={url}>  
              {title}
            </a>
          </h4>
          <p className='content'>{details}</p>
        </div>
      </div>
    </div>
  );
} 
